"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const material_1 = require("@mui/material");
const DialogTitle_1 = tslib_1.__importDefault(require("@mui/material/DialogTitle"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const pure_utils_1 = require("@mnemonic/pure-utils");
const ArgusUtils = tslib_1.__importStar(require("@mnemonic/pure-utils/ArgusUtils"));
const FallbackAppBarButton_1 = tslib_1.__importDefault(require("./FallbackAppBarButton"));
const FallbackAppBarContactUs = () => {
    const theme = (0, material_1.useTheme)();
    const [open, setOpen] = (0, react_1.useState)(false);
    const metaInfo = ArgusUtils.getMetaInfo();
    const addressParts = metaInfo?.address?.split(", ");
    const ArgusMenuButtonProps = {
        disableShrinking: true,
        disableIconOffset: true,
        ListItemTextProps: { sx: { color: "common.white", whiteSpace: "nowrap" } },
        ListItemProps: { sx: { p: 0 } },
        label: "Contact Us",
        onClick: () => setOpen(!open),
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(FallbackAppBarButton_1.default, { ...ArgusMenuButtonProps }),
        react_1.default.createElement(material_1.Dialog, { open, onClose: () => setOpen(false), fullWidth: true, maxWidth: "xs" },
            react_1.default.createElement(DialogTitle_1.default, { sx: { display: "flex", alignItems: "center" } }, "Contact Us"),
            react_1.default.createElement(material_1.DialogContent, { sx: { borderLeft: `${theme.spacing(3)} solid ${theme.palette.secondary.main}`, pb: 0, pl: 1, mb: "20px" } },
                react_1.default.createElement(Typography_1.default, { gutterBottom: true, color: "secondary", variant: "body2" }, metaInfo?.name),
                react_1.default.createElement(Typography_1.default, null, addressParts?.[0]),
                addressParts.length > 1 && react_1.default.createElement(Typography_1.default, null, addressParts?.slice(1).join(", ")),
                react_1.default.createElement(Typography_1.default, null, metaInfo?.email),
                react_1.default.createElement(react_1.default.Fragment, null, metaInfo?.phoneNumber?.map((number, index) => {
                    // Handled by formattedPhoneNumber()
                    const nationalNumber = number?.replace("+47", "");
                    return (react_1.default.createElement(Typography_1.default, { key: number },
                        index === 0 && "Tel: ",
                        index === 1 && "Alt: ",
                        index > 1 && `Alt ${index}: `,
                        (0, pure_utils_1.formattedPhoneNumber)({ nationalNumber, countryCode: "47" })));
                }))))));
};
exports.default = FallbackAppBarContactUs;
